import React, { FC, ReactElement } from 'react';
import { View } from 'react-native';
import ColorWrapper from '@styles/colors';
import { TourTarget } from '@components/tours';
import { WELCOME_TOUR_IDS } from '@components/tours/config/global/welcome/constants';
import { injectConditionalObject } from '@helpers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useManageTopBlock } from './hooks/useManageTopBlock';
import LinkedOrUnknownNCFileTopBlock from './LinkedOrUnknownNCFileTopBlock';
import ChangeOrIgnoredNCFileTopBlock from './ChangeOrIgnoredNCFileTopBlock';
import SetupNCFileTopBlock from './SetupNCFileTopBlock';
import { BaseTopBlockProps, NCFileFirstRanInfoProp, TopBlockVariant } from './types';

interface TopBlockProps extends BaseTopBlockProps, NCFileFirstRanInfoProp {}

const TopBlock: FC<TopBlockProps> = ({ C, ncFileFirstRanInfo }) => {
  const {
    onTopBlockImagePress,
    onTopBlockPress,
    variant,
    ncFileName,
    shouldDisplayNCFileNameForLinkedUnknownNCFileBlock,
    batchLoaded,
  } = useManageTopBlock();

  const variantRenderers: Record<TopBlockVariant, () => ReactElement> = {
    [TopBlockVariant.CHANGE_OR_IGNORED]: () => (
      <ChangeOrIgnoredNCFileTopBlock
        C={C}
        ncFileFirstRanInfo={ncFileFirstRanInfo}
        ncFileName={ncFileName ?? ''}
        onModifyNCFileTypePress={onTopBlockPress}
      />
    ),
    [TopBlockVariant.SETUP]: () => <SetupNCFileTopBlock C={C} ncFileName={ncFileName ?? ''} onTopBlockImagePress={onTopBlockImagePress} />,
    [TopBlockVariant.LINKED_OR_UNKNOWN]: () => (
      <LinkedOrUnknownNCFileTopBlock
        C={C}
        onTopBlockPress={batchLoaded ? onTopBlockPress : undefined}
        onTopBlockImagePress={onTopBlockImagePress}
        {...injectConditionalObject(shouldDisplayNCFileNameForLinkedUnknownNCFileBlock && !!ncFileName, { ncFileName })}
      />
    ),
  };

  return (
    <TourTarget tourId={WELCOME_TOUR_IDS.LIVE_TOP_BLOCK}>
      <View testID={TEST_IDS.liveScreen.topBlockWrapper}>{variantRenderers[variant]()}</View>
    </TourTarget>
  );
};

export default ColorWrapper(TopBlock);
